import BigNumberInput from './BigNumberInput';

export default BigNumberInput;
